import { Box, Grid } from '@mui/material'
import { backgroundColors } from '../Components/Common/Color/Color'
import MyProfile from '../Components/Settings/MyProfile'
// import NotificationSettings from '../Components/Settings/NotificationSettings'

// Main Component
const Settings = () => {
  return (
    <Box
      component='div'
      sx={{ p: 0, backgroundColor: backgroundColors.white, width: 'auto' }}
      borderRadius={2}
      boxShadow={1}
    >
      <Box>
        <Grid container spacing={2} sx={{ p: 2 }} direction={'column'}>
          <Grid size={12}>
            <MyProfile />
          </Grid>
          {/* <Grid size={12}>
            <NotificationSettings />
          </Grid> */}
        </Grid>
      </Box>
    </Box>
  )
}

export default Settings
